enum SupportedLanguages {
  FR = 'fr',
  EN = 'en',
  DEFAULT = 'fr'
}

export default SupportedLanguages;
